<template>
	<div class="success-join" v-if="loading">
		<span class="icon iconfont iconlujing2 close"  :class="{'bsStyle': s === 'BS' }"  @click="goPath"></span>
		<div class="success-code-wrap">
			<div class="logo">
				<span class="icon iconfont iconxingzhuangjiehe4"></span>
			</div>
			<p class="success-text">VIP订购成功</p>
			<p class="desc days">会员权益已开通</p>
			<p class="desc">会员有效期{{originVip ? '延长': ''  }}至<span class="date">{{ date }}</span></p>
			<button class="btn btn-blue-transparent" @click="goPath">返回首页</button>
		</div>
	</div>
</template>

<script>
	import { reqGetPayResult, reqPayResultConfirmByOrderId } from '../../../api';
	import { isEmptyObject } from '../../../utils';
	import { Toast } from 'vant';

	export default {
		name: 'successCode',
		data() {
			return {
				date: "",
				loading: false,
				originVip: null, // 开通前vip状态
				requestOrderId: null,  // 支付单id
				orderId: null, // 订单id
				s: localStorage.getItem('s')
			}
		},
		mounted() {
			this.orderId = this.$route.query.orderId || null
			this.requestOrderId = this.$route.query.requestOrderId || null
			this.originVip = this.$route.query && this.$route.query.originVip ? this.$route.query.originVip : null
			Toast.loading({
				duration: 0,
				message: '订单查询中...',
				forbidClick: true
			})
			// 获取支付订单信息
			if (this.orderId || this.requestOrderId) {
				this.timer = setInterval(() => this.getPayResult(), 1000);
			}
			setTimeout(()=>{
				if(this.timer){
					clearInterval(this.timer);
				}
			},120000) // 2分钟之后不再查询订单，跳转到首页
		},
		destroyed() {
			clearInterval(this.timer)
		},
		methods: {
			// 查询支付结果
			getPayResult(){
				if(this.requestOrderId){
					this.getPayResultByRequestId()
				}else if(this.orderId){
					this.getPayResultByOrderId()
				}
			},
			// 通过支付单id查询订单状态
			getPayResultByRequestId(){
				reqGetPayResult({requestOrderId: this.requestOrderId}).then((res)=>{
					this.loading = true
					if(res.ok && !isEmptyObject(res)){
						this.date = res.data.vipEndTimeStr
						clearInterval(this.timer);
						Toast.clear()
					}else {
						Toast(res.msg)
					}
				})
			},
			// 通过订单id查询订单状态
			getPayResultByOrderId(){
				reqPayResultConfirmByOrderId({orderId: this.orderId}).then((res)=>{
					this.loading = true
					if(res.ok && !isEmptyObject(res)){
						this.date = res.data.vipEndTimeStr
						clearInterval(this.timer);
						Toast.clear()
					}else {
						Toast(res.msg)
					}
				})
			},
			goPath() {
				this.$router.push('/home')
			}
		}
	};
</script>

<style lang="less" scoped>
	.success-join {
		padding: 0 30px;
		position: relative;
		.close {
			position: absolute;
			top: 16px;
			left: 16px;
		}
		.close.bsStyle{
			top: 46px;
		}
		.success-code-wrap{
			display: flex;
			flex-direction: column;
			align-items: center;
			.logo {
				height: 60px;
				line-height: 60px;
				margin-top: 110px;
			}
			/deep/ .iconfont {
				font-size: 60px;
				color: @baseGreen;
			}
			.success-text {
				margin-top: 20px;
				height:24px;
				font-size:24px;
				font-family:PingFangSC-Semibold,PingFang SC;
				font-weight:600;
				color:@darkBlack;
				line-height:24px;
			}
			.desc {
				margin-bottom: 10px;
				font-size: 12px;
				color: #999999;
				&.days{
					color: #FA9D3B;
					margin-top: 20px;
				}
			}
			.date {
				color: #333333;
				margin-left: 5px;
			}
			.btn {
				margin-top: 110px;
			}
		}
	}
</style>
